import type { FaireProductEntity } from "../../entity_types/product";

export const p_vtjkqq4c6x: FaireProductEntity = {
  token: "p_vtjkqq4c6x",
  type: "product",
  name: "Muk Luks Women's Short Cable Slipper Sock",
  brandToken: "b_ctdl51blev",
  brandName: "Muk Luks",
  imageUrl:
    "https://cdn.faire.com/fastly/7159ff16a84ca31560da53d466376ffb2b4042a92f4c056f12c2590f58fe890a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b0e5c6b72c207296511e69518dd12cebbf541b78b8163d464e932b7c0d8e9bdc.jpeg",
  ],
  priceDollars: 10,
  description:
    "MUK LUKS® Women's Short Cable Slipper Socks combine cozy warmth with a chic design. The ribbed cuff and wood button detail make them a fashionable addition to your winter wardrobe.\n\nMachine wash cold on gentle cycle, no bleach, tumble dry low heat.\n\n• 1 Pair pack\n• Wood button detail\n• Fully Lined with faux shearling\n• Ribbed Cuff\n• Available in Women's US Sizes S/M (5-7) and L/XL (8-10)",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:36.509Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
